import { types } from './AppAction';
import { CONTEXT_SWITCH_REQUEST, CONTEXT_SWITCH_RECEIVE } from './contextSwitchActions';
import { USER_LOGOUT } from '../Login/LoginAction';

const initialState = { initialized: false, switchingContext: false, contextSwitchMessage: null };

export default (state = initialState, action) => {
  switch (action.type) {
    case types.APP_INITIALIZING:
      return { ...state, initialized: false };
    case types.APP_INITIALIZED:
      return { ...state, initialized: true };
    case CONTEXT_SWITCH_REQUEST:
      return { ...state, switchingContext: true, contextSwitchMessage: action.message };
    case CONTEXT_SWITCH_RECEIVE:
      return { ...state, switchingContext: false, contextSwitchMessage: null };
    case USER_LOGOUT:
      return { ...state, switchingContext: false, contextSwitchMessage: null };
    default:
      return state;
  }
};
